import { ORGANIZATION_SLUG } from 'service/constants'
import constants from 'constants/index'

// Resolve o slug efetivo para redirects, preservando o white-label através das
// telas de loading (Microsoft volta sem slug; SSO volta com /dponet/sso).
// Ordem: slug real da URL > slug salvo no storage > slug padrão da plataforma.
const resolveSlug = (slug) => {
  const { PLATFORM_SLUG_ID, DEFAULT_SLUGS_PATHS } = constants.settings

  if (slug && !DEFAULT_SLUGS_PATHS.includes(slug?.toLowerCase())) return slug

  return sessionStorage.getItem(ORGANIZATION_SLUG) || PLATFORM_SLUG_ID
}

export default resolveSlug
